import clsx from 'clsx'
import React, { FC } from 'react'

import { Button } from '@CoreComponents/Buttons/Button'
import styles from '@Domains/Checkout/EmptyCart/EmptyCart.module.scss'
import { useSplitTest } from '@Globals/SplitTests/Hooks'
import { useTranslation } from '@Globals/Translations'

export const CheckoutEmptyCart: FC = () => {
  const cofDesignV1 = useSplitTest('cof_design_v1', 'b')
  const { t } = useTranslation()

  return (
    <div className={clsx(styles.emptyCart, cofDesignV1 && styles.cofDesignV1)}>
      <p className={styles.text}>{t('checkout:COF_NO_PRODUCTS_IN_CART_TEXT')}</p>
      <Button
        href="/"
        innerSpacing="medium"
        theme={cofDesignV1 ? 'black' : 'primary'}
      >
        {t('checkout:COF_BACK_TO_HOMEPAGE')}
      </Button>
    </div>
  )
}
